import { useForm } from "react-hook-form"
import { useContext, useEffect } from "react";
import { ToastDataContext } from "./context/ToastContextProvider";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { classNames } from "./App";
import ErrorManagement, { addErrorToClass } from "./components/errormanagement";
import { resetPasswordEndpoint } from "./hr_endpoints";
import { useNavigate, useParams } from "react-router-dom";
import CustomPasswordInput from "./components/passwordInput";
import PasswordRules, { passwordRule } from "./components/passwordRules";

export default function ResetPassword({ }) {

    const { token } = useParams()

    const navigate = useNavigate()

    const schema = yup.object({
        token: yup.string().required('Acest câmp este obligatoriu'),
        password: yup.string().required('Acest câmp este obligatoriu') // Field is required
            .test(...passwordRule("length", 'Parola trebuie să aibă minim 8 caractere'))
            .test(...passwordRule("uppercase", 'Parola trebuie să conțină cel puțin o literă mare'))
            .test(...passwordRule("special", 'Parola trebuie să conțină cel puțin un caracter special')),
        confirm_new_password: yup.string().required("Acest câmp este obligatoriu!")
            .oneOf([yup.ref('password'), null], 'Parolele trebuie să coincidă')
    })

    const { register, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm({
        resolver: yupResolver(schema)
    })

    // The rule checklist fills in while the new password is typed.
    const passwordValue = watch('password', '')

    useEffect(() => {
        if (token) {
            setValue('token', token)
        }
    }, [token])

    const toastContext = useContext(ToastDataContext)

    const onSubmit = async (data) => {
        const response = await fetch(resetPasswordEndpoint, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })

        if (!response.ok) {
            toastContext.error(await response.text());
        } else {
            const result = await response.json()
            switch (result.userType) {
                case 'EMPLOYEE':
                    navigate('/login/employee')
                    break;
                case 'ADMINISTRATOR':
                    navigate('/login/admin')
                    break;
                case 'HR':
                    navigate('/login/hr')
                    break;
                case 'THERAPIST':
                    navigate('/login/therapist')
                    break;
                default:
                    navigate('/login/employee')
                    break
            }
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="card w-full max-w-md shadow-2xl bg-base-100 animate__animated animate__fadeIn animate__faster">

                <div className="card-body">
                    <div className="flex flex-col items-center gap-2 mb-4">
                        <div className="placeholder">
                            <img
                                alt="TeamUp Logo"
                                src="/logo.svg"
                                className="h-40 w-auto mb-[-3rem]"
                            />
                        </div>
                        <h2 className="mt-4 text-2xl font-bold">Resetează parola</h2>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Token</span>
                            </label>
                            <input type="text" {...register('token')} readOnly className={classNames("input input-bordered hover:input-primary focus:input-primary", addErrorToClass(errors.token))} required />
                            <ErrorManagement errorObj={errors.token} />
                        </div>

                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Parolă nouă</span>
                            </label>
                            <CustomPasswordInput
                                register={register('password')}
                                className={classNames("input input-bordered hover:input-primary focus:input-primary", addErrorToClass(errors.password))}
                                autoComplete="new-password"
                                showLabel={"Arată parola"}
                                hideLabel={"Ascunde parola"}
                                required
                            />
                            <ErrorManagement errorObj={errors.password} />
                            <PasswordRules
                                password={passwordValue}
                                labels={{
                                    length: "Cel puțin 8 caractere",
                                    uppercase: "Cel puțin o literă mare",
                                    special: "Cel puțin un caracter special",
                                }}
                            />
                        </div>

                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Confirmă parola nouă</span>
                            </label>
                            <CustomPasswordInput
                                register={register('confirm_new_password')}
                                className={classNames("input input-bordered hover:input-primary focus:input-primary", addErrorToClass(errors.confirm_new_password))}
                                autoComplete="new-password"
                                showLabel={"Arată parola"}
                                hideLabel={"Ascunde parola"}
                                required
                            />
                            <ErrorManagement errorObj={errors.confirm_new_password} />
                        </div>

                        <div className="form-control mt-6">
                            <button className="btn bg-primary hover:bg-primary-dark">
                                Trimite
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

}